import { IValidationRule } from "@/types"

const tenantContactsValidationRules: { [s: string]: IValidationRule } = {
    street: {
        required: true
    },
    zip: {
        required: true,
    },
    city: {
        required: true,
    },
    countryName: {
        required: true,
    },
    vat: {
        required: true,
    },
    phoneNumber: {
        required: true,
    },
    email: {
        type: "email",
    },
    bankName: {
        required: true,
    },
    iban: {
        required: true,
    },
    bic: {
        required: true,
    }
}

export default tenantContactsValidationRules
